import {createBrowserRouter} from "react-router-dom";
import Layout from "./components/Layout/Layout";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import Error404 from "./pages/ErrorPage/Error404";
import Home, {loader as homeLoader} from "./pages/Home/Home";
import Search, {loader as searchLoader , action as searchAction} from "./pages/Search/Search";
import Excursion, {loader as excursionLoader} from "./pages/Excursion/Excursion";
import ExcursionTerms, {loader as excursionTermsLoader} from "./pages/ExcursionTerms/ExcursionTerms";
//import QRLink, {loader as QRLinkLoader} from "./pages/QRLink/QRLink";  //No se utiliza ya se realiza por redireccion desde el .htaccess
import Cart from "./pages/Cart/Cart";
import FinalBooking from "./pages/FinalBooking/FinalBooking";
import LegalTerms from "./pages/StaticPage/LegalTerms/LegalTerms";
import Faq from "./pages/StaticPage/Faq/Faq";
import Company from "./pages/StaticPage/Company/Company";
import ExperienceLaGomera from "./pages/Experiences/LaGomera/LaGomera";
import ExperienceTeideByNight from "./pages/Experiences/TeideByNight/TeideByNight";

export const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <ErrorPage/>,
    children: [
      {
        errorElement: <ErrorPage/>,
        children: [
          {
            path: "/:language?/:zone?",
            element: <Home />,
            loader:homeLoader,
            action:searchAction,
          },
          {
            path: "/:language?/search/:zone?",
            element: <Search />,
            loader:searchLoader,
            action:searchAction,
          },
          {
            path: "/:language?/search/:zone?/:slug",
            element: <Search />,
            loader:searchLoader,
          },
          {
            path: "/:language?/excursion/:zone?/:slug",
            element: <Excursion />,
            loader:excursionLoader,
          },
          {
            path: "/:language?/cart",
            element: <Cart />,
          },
          {
            path: "/:language?/final-booking",
            element: <FinalBooking />,
          },
          {
            path: "/:language?/company",
            element: <Company />,
          },
          {
            path: "/:language?/faq",
            element: <Faq />,
          },
          {
            path: "/:language?/legal-terms",
            element: <LegalTerms />,
          },
          {
            path: "/:language?/experiences/la-gomera",
            element: <ExperienceLaGomera />,
          },
          {
            path: "/:language?/experiences/teide-by-night",
            element: <ExperienceTeideByNight />,
          },
          {
            path: "/:language?/excursionterms/:id?/",
            element: <ExcursionTerms />,
            loader:excursionTermsLoader,
          },
          {/*
            path: "/:language?/qrlink/:key?/",
            element: <QRLink />,
            loader:QRLinkLoader,*/
          },
          {
            path: "/:language?/transparencia",
            element: <h1>transparencia</h1>,
          },
          {
            path: "/:language?/blog",
            element: <h1>blog</h1>,
          },
          {
            path: "*",
            element: <Error404/>,
          },

        ]
      }
    ]
  }
]);
